export default "__VITE_ASSET__BCU2EDnb__"